
import { mapState, mapActions, mapMutations } from "vuex";
import AppReceiverPrint from "./app-receiver-print.vue";
export default {
  components: { AppReceiverPrint },
  props: {
    initValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    configName: {
      type: String,
      default: ""
    },
    isEnabled: {
      type: Boolean,
      default: true
    },
    selectedRestaurant: {
      type: Object,
      default: {}
    },
    showAddPrinter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: false,
      loading: false
    };
  },
  beforeMount() {
    this.initVal();
  },
  watch: {
    initValue() {
      this.initVal();
    }
  },
  methods: {
    ...mapActions("restaurant", ["updateRestaurantSettings"]),
    initVal() {
      this.value = !!this.initValue;
    },
    async handleChange() {
      this.loading = true;
      if (this.type === "restaurant-setting") {
        try {
          await this.updateRestaurantSettings({
            settings: {
              [this.configName]: this.value
            },
            id: this.selectedRestaurant.id
          });
          this.$nuxt.$emit("show-toast", {
            text: "Configuration updated successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        } catch (err) {
          this.initVal();
          this.$nuxt.$emit("show-error-toast", err);
        }
        this.loading = false;
      }
    }
  }
};
